import auth, { STORAGE_ROOMS_TOKEN } from 'base/auth';

// export const apiURL = 'https://api.naizecie.pl';
export const apiURL = 'https://rajd-app-v1-api.napwr.pl';
// export const apiURL = 'http://192.168.2.106:3982';
// export const apiURL = 'http://localhost:3982';
// export const apiURL = 'http://rajd-api.kopecmaciej.pl';

const API = {
    ADD: `${apiURL}/api/student/add`,
    GET_STUDENT_BY_INDEX: `${apiURL}/api/student/get/`,
    GET_ALL_STUDENTS: `${apiURL}/api/student/getAll`,
    GET_DELETED: `${apiURL}/api/student/getDeleted`,
    DELETE_STUDENT: `${apiURL}/api/student/delete/`,
    UPDATE_STUDENT: `${apiURL}/api/student/update/`,
    SEND_MAILS: `${apiURL}/api/mailer/send`,
    GET_EVENT_INFO: `${apiURL}/api/info/get`,
    UPDATE_EVENT_INFO: `${apiURL}/api/info/updateInfo`,
    AUTH: `${apiURL}/api/user/auth`,
    EXCEL_UPLOAD: `${apiURL}/api/exce/upload`,
    ADD_ROOM: `${apiURL}/api/room/add`,
    GET_ROOMS: `${apiURL}/api/room/getAll`,
    DELETE_ROOM: `${apiURL}/api/room/delete/`,
    GET_STUDENT: `${apiURL}/api/room/getStudent`,
    GET_ROOM_DATA: `${apiURL}/api/room/openRoom/`,
    UPDATE_ROOM: `${apiURL}/api/room/saveRoom/`,
    LEAVE_ROOM: `${apiURL}/api/room/leaveRoom`,
}

// const getToken =
// const getToken = 'aaa';

export const GET_AUTH = {
    method: 'GET',
    headers: new Headers({
        'Content-Type': 'application/json',
        "Authorization": auth.getToken()
    })
};

export const GET_AUTH_ROOMS = {
    method: 'GET',
    headers: new Headers({
        'Content-Type': 'application/json',
        "Authorization": auth.getToken(STORAGE_ROOMS_TOKEN)
    })
};

export const AUTH_HEADER = {
    'Content-Type': 'application/json',
    "Authorization": auth.getToken()
};

export const AUTH_HEADER_ROOMS = {
    'Content-Type': 'application/json',
    "Authorization": auth.getToken(STORAGE_ROOMS_TOKEN)
};

export default API;



// WEBPACK FOOTER //
// ./src/base/api.js